<template>
  <div id="app">
    <router-view></router-view>
    <!-- <image-dialog ref="imageDialog"  :max="maxChooseImage"></image-dialog> -->
  </div>
</template>

<script>
import imageDialog from "@/components/image/image-dialog.vue";
export default {
  components: {
    imageDialog,
  },
  name: "app",
  // 依赖注入
  provide() {
    return {
      app: this,
    };
  },

  data() {
    return {
      maxChooseImage: 9,
      path: "",
    };
  },
  methods: {
    chooseImage(callback, max = 9) {
      this.maxChooseImage = max;
      this.$refs.imageDialog.chooseImage(callback);
    },
  },
};
</script>
<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>

<style>
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.25);
  transition: color 0.2s ease;
}
.el-icon-circle-close {
  color: #fff;
}
ul {
  list-style-type: circle;
  list-style-type: square;
  list-style-type: none;
}
</style>
